import authHeaders from 'helpers/auth-header';
import request from './api';

function getEodReportsByMerch(vkn, startDate, endDate, branchId, currentPage = 1, pageSize = 50) {
  return request({
    url: `/report/eod/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/client-id/0/page-no/${currentPage}/page-size/${pageSize}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getEodReportsByBranch(vkn, branchId, startDate, endDate) {
  return request({
    url: `/report/eod/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getEodReportsByTerminal(vkn, branchId, terminalId, startDate, endDate) {
  return request({
    url: `/report/eod/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/client-id/${terminalId}/page-no/1/page-size/50`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getEodReportsByTxn(vkn, branchId, terminalId, startDate, endDate) {
  return request({
    url: `/report/eod/txn/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/client-id/${terminalId}/page-no/1/page-size/50`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getEodReportsByMerchExcel(vkn, startDate, endDate) {
  return request({
    url: `/report/eod/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getEodReportsByBranchExcel(vkn, branchId, startDate, endDate) {
  return request({
    url: `/report/eod/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getEodReportsByTerminalExcel(
  vkn,
  branchId,
  terminalId,
  startDate,
  endDate,
  currentPage = 1,
  pageSize = 50,
) {
  return request({
    url: `/report/eod/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/client-id/${terminalId}/page-no/${currentPage}/page-size/${pageSize}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getEodReportsExcel(
  vkn,
  raporTuru,
  branchId,
  terminalId,
  startDate,
  endDate,
  currentPage = 1,
  pageSize = 50,
) {
  return request({
    url: `/report/eod/identification-number/${vkn}/rapor-turu/${raporTuru}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/client-id/${terminalId}/page-no/${currentPage}/page-size/${pageSize}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getMyInvoicesReports(vkn, startDate, endDate, branchId) {
  return request({
    url: `/report/invoice/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getMyInvoicesReportsExcel(vkn, startDate, endDate, branchId) {
  return request({
    url: `/report/invoices/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getPayeInvoicesReports(vkn, startDate, endDate, branchId) {
  return request({
    url: `/report/paye-invoice/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getPayeInvoicesReportsExcel(vkn, startDate, endDate, branchId) {
  return request({
    url: `/report/paye-invoices/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getPaymentReports(vkn, startDate, endDate, branchId) {
  return request({
    url: `/report/payments/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/lastRowCount/49`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getPaymentReportsExcel(vkn, startDate, endDate, branchId) {
  return request({
    url: `/report/payments/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/lastRowCount/49/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getCurrentAccountReports(vkn, startDate, endDate, branchId) {
  return request({
    url: `/report/current-account/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getCurrentAccountReportsExcel(vkn, startDate, endDate, branchId) {
  return request({
    url: `/report/current-account/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getBabsReports(vkn, year, month, type) {
  return request({
    url: `/report/ba-bs/identification-number/${vkn}/year/${year}/month/${month}/type/${type}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getBabsReportsExcel(vkn, year, month, type) {
  return request({
    url: `/report/ba-bs/identification-number/${vkn}/year/${year}/month/${month}/type/${type}/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getEodReportsByAgreementIdExcel(vkn, startDate, endDate, branchId, clientId, agreementId) {
  return request({
    url: `/report/eod/identification-number/${vkn}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/client-id/${clientId}/agreementId/${agreementId}/page-no/1/page-size/49/excel`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function getBabsReportsPdf(vkn, year, month, type) {
  return request({
    url: `/report/ba-bs/identification-number/${vkn}/year/${year}/month/${month}/type/${type}/pdf`,
    method: 'GET',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    accept: '*/*',
  });
}

function sentMailBABS(body) {
  return request({
    url: `/report/sendBaBsMail/INDIVIDUAL`,
    method: 'POST',
    headers: authHeaders(),
    data: { ...body },
  });
}

function getBabsReportsSelectedPdf(body) {
  return request({
    url: `/report/ba-bs-details/pdf`,
    method: 'POST',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    data: { ...body },
  });
}

function getInvoiceReportsSelectedPdf(identificationNumber, body) {
  return request({
    // url: `/report/corporate-invoices-details/identification-number/${identificationNumber}/invoiceNumber/${invoiceNumber}/pdf`,
    url: `/report/invoiceFromUrl/identification-number/${identificationNumber}`,
    // method: 'GET',
    method: 'POST',
    headers: authHeaders(),
    responseType: 'arraybuffer',
    data: { ...body },
  });
}

function getEodReportsByMerchNotInvoice(
  identificationNumber,
  startDate,
  endDate,
  branchId,
  clientId,
  agreementId = 0,
  currentPage = 1,
  pageSize = 50,
) {
  return request({
    url: `/report/eod/identification-number/${identificationNumber}/start-date/${startDate}/end-date/${endDate}/branch-id/${branchId}/client-id/${clientId}/agreementId/${agreementId}/page-no/${currentPage}/page-size/${pageSize}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function manualInvoicing(identificationNumber, body) {
  return request({
    url: `/report/do-invoice/identification-number/${identificationNumber}`,
    method: 'POST',
    headers: authHeaders(),
    data: { ...body },
  });
}

const report = {
  getEodReportsByMerch,
  getEodReportsByBranch,
  getEodReportsByTerminal,
  getEodReportsByTxn,
  getEodReportsByMerchExcel,
  getEodReportsByBranchExcel,
  getEodReportsByTerminalExcel,
  getEodReportsExcel,
  getEodReportsByAgreementIdExcel,
  getMyInvoicesReports,
  getMyInvoicesReportsExcel,
  getPayeInvoicesReports,
  getPayeInvoicesReportsExcel,
  getPaymentReports,
  getPaymentReportsExcel,
  getCurrentAccountReports,
  getCurrentAccountReportsExcel,
  getBabsReports,
  getBabsReportsExcel,
  getBabsReportsPdf,
  sentMailBABS,
  getBabsReportsSelectedPdf,
  getInvoiceReportsSelectedPdf,
  getEodReportsByMerchNotInvoice,
  manualInvoicing,
};

export default report;
